import { render, staticRenderFns } from "./HomeForHRs.vue?vue&type=template&id=38ae9a98&scoped=true&"
import script from "./HomeForHRs.vue?vue&type=script&lang=js&"
export * from "./HomeForHRs.vue?vue&type=script&lang=js&"
import style0 from "./HomeForHRs.vue?vue&type=style&index=0&id=38ae9a98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae9a98",
  null
  
)

export default component.exports